export default "__VITE_ASSET__bffa4bf6__"